module.exports = __webpack_public_path__ + "static/img/right-little.20467be9.png";